import React from 'react';
import Highlighter from 'react-highlight-words';
import RichTextDisplay from '../../../components/textEditor/RichTextDisplay';
import ChapterGoal from '../FinancialStory/advisor-components/chapter-components/ChapterGoal';

const OngoingAdvice = ({ item, query }) => {
  // For search context, we'll use basic query keys that make sense for search results
  const searchQueryKey = ['hh-search', item?.household_id];
  const goalsListQueryKey = `goals-${item?.household_id}`;
  const activeChaptersListQueryKey = `active-financial-story-chapters-list-${item?.household_id}`;
  const completedChaptersListQueryKey = `financial-story-completed-chapters-list-${item?.household_id}`;

  // Set up query keys for ChapterGoal component
  const queryKeys = {
    goals: goalsListQueryKey,
    chapters: activeChaptersListQueryKey,
    active: activeChaptersListQueryKey,
    completed: completedChaptersListQueryKey,
    search: searchQueryKey,
  };

  return (
    <div className="">
      {/* Display chapter name if available */}
      {item?.title && (
        <div className="mb-2 text-sm text-gray-600 bg-gray-50 px-2 py-1 rounded">
          <span className="font-medium">Chapter:</span> {item.title}
        </div>
      )}

      <ChapterGoal
        goal={item}
        queryKeys={queryKeys}
        query={query}
      />
    </div>
  );
};

export default OngoingAdvice;
